import * as loginActions from './login';
import * as logoutActions from './logout';
import * as homeActions from './home';
import * as jobActions from './job';
import * as UserActions from './user';
import * as RecruitActions from './recruit';
import * as TalentActions from './talent';
import * as ResumeActions from './resume-info';
import * as TaskActions from './task';
import * as EmailActions from './email';
import * as FileActions from './file';
import * as ManageActions from './manage';
import * as SearchActions from './resumeSearch';
import * as SalaryActions from './salaryReport';
import * as IntellHRActions from './intellHR';
import * as InterviewActions from './interview';
import * as DownloadQRActions from './downloadQR';
import * as AddInterviewsActions from './addInterview';



module.exports =  {
    loginActions,
    logoutActions,
    homeActions,
    jobActions,
    RecruitActions,
    TalentActions,
    UserActions,
    ResumeActions,
    TaskActions,
    EmailActions,
    FileActions,
    ManageActions,
    SearchActions,
    SalaryActions,
    IntellHRActions,
    InterviewActions,
    DownloadQRActions,
    AddInterviewsActions
}



// WEBPACK FOOTER //
// ./src/actions/index.js